import React, { useEffect, useRef, useState } from 'react';

import Column from '@amzn/meridian/column';

import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

interface LoadingSkeletonProps {
    /** Trigger to remeasure when tab becomes active */
    isActive?: boolean;
}

export const LoadingSkeleton: React.FC<LoadingSkeletonProps> = ({ isActive = true }) => {
    const [skeletonCount, setSkeletonCount] = useState(15);
    const containerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (isActive && containerRef.current) {
            // Use setTimeout to ensure DOM has updated
            setTimeout(() => {
                if (containerRef.current) {
                    const containerHeight = containerRef.current.clientHeight;
                    const skeletonRowHeight = 20; // Approximate height of each skeleton row
                    const calculatedCount = Math.floor(containerHeight / skeletonRowHeight);
                    setSkeletonCount(calculatedCount > 0 ? calculatedCount : 15);
                }
            }, 0);
        }
    }, [isActive]);

    return (
        <Column height="100%" width="100%" ref={containerRef}>
            <Skeleton count={skeletonCount} />
        </Column>
    );
};
